import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import * as Sentry from '@sentry/react'
import {config} from './config.ts'
import {name} from '../package.json'
import './main.css'

Sentry.init({
  dsn: config.sentry.dsn,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', config.restApi.url],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: config.environmentName,
  release: config.commitSha,
  dist: name.replace(/.*\//, ''),
  enabled: config.environmentName !== 'local',
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
